import { TooltipPosition } from "@kamae-apps/shared/Components/Atoms/Tooltip/Tooltip"
import { IconNames } from "@kamae-apps/shared/Components/Fondations/Icons/IconNames.type"
import clsx from "clsx"
import { FC, MouseEventHandler } from "react"
import { v4 } from "uuid"
import { Divider } from "../Components/Divider"
import { Section } from "../Components/Section"
import { MenuButton } from "./Components/MenuButton"
import styles from "./Menu.module.css"

type DropdownMenuProps = {
  onCloseMenu: () => void
  entries: DropdownMenuEntries[]
}

export type DropdownMenuEntries = {
  content?: DropdownMenuContent
  divider?: boolean
  menuSection?: string
}

export type DropdownMenuContent = {
  disabledTooltip?: string
  disabledTooltipPosition?: TooltipPosition
  iconName: IconNames
  isDanger?: boolean
  onClick: MouseEventHandler<HTMLButtonElement>
  isDisabled?: boolean
  displayNameKey: string
}

export const DropdownMenu: FC<DropdownMenuProps> = ({ onCloseMenu, entries }) => {
  return (
    <div className={clsx(styles.menu)}>
      {entries.map(entry => {
        if (entry.divider) return <Divider key={v4()} />

        if (entry.menuSection) {
          return (
            <Section
              key={entry.menuSection}
              value={entry.menuSection}
            />
          )
        }

        if (entry.content) {
          return (
            <MenuButton
              key={entry.content.displayNameKey}
              content={entry.content}
              onCloseMenu={onCloseMenu}
            />
          )
        }
      })}
    </div>
  )
}
